// Bearer credentials for dev builds: access token in memory, refresh token in localStorage.
const REFRESH_KEY = "tank.refresh";

let access = "";
let accessExpiresAt = 0;

function read(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

function write(key: string, value: string): void {
  try {
    if (value) localStorage.setItem(key, value);
    else localStorage.removeItem(key);
  } catch {
    // storage unavailable (private mode); the session lives for this tab only
  }
}

export const tokens = {
  set(input: { accessToken: string; refreshToken: string; accessExpiresAtMs?: number }): void {
    access = input.accessToken;
    accessExpiresAt = input.accessExpiresAtMs ?? Date.now() + 9 * 60_000;
    write(REFRESH_KEY, input.refreshToken);
  },
  access(): string {
    return access;
  },
  /** True when the access token is missing or within 30 s of expiring. */
  accessStale(now = Date.now()): boolean {
    return !access || now >= accessExpiresAt - 30_000;
  },
  refresh(): string {
    return read(REFRESH_KEY);
  },
  clear(): void {
    access = "";
    accessExpiresAt = 0;
    write(REFRESH_KEY, "");
  },
};
